// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reactMarkdown table {\r\n    width: 100%;\r\n    max-width: 100%;\r\n}\r\n", "",{"version":3,"sources":["webpack://./Client/source/misc/components/Formatters/MarkdownStyles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;AACnB","sourcesContent":[".reactMarkdown table {\r\n    width: 100%;\r\n    max-width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
